export default {
    cookie: {
        get: function(name) {
            name = name + '=';
            let cookie_data = document.cookie;
            let start = cookie_data.indexOf(name);
            let value = '';
            if (start != -1){
                start += name.length;
                let end = cookie_data.indexOf(';', start);
                if(end == -1) {
                    end = cookie_data.length;
                }
                value = cookie_data.substring(start, end);
            }
            return value;
        },
        set: function(name, value, expiredays) {
            let today = new Date();
            today.setTime(today.getTime() + 1000 * 60 * 60 * parseInt(expiredays));
            document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${today.toGMTString()}; domain=.${document.domain}`;
            // document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; expires=' + today.toGMTString() + '; domain=.'+ document.domain;
        },
        remove: function(name) {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1999 00:00:10 GMT;`;
        },
    },
    comma: function(string) {
        let strings = String(string).split('.');
        strings[0] = String(strings[0]).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        // console.log('comma', strings, strings.join('.'))
        return (strings.join('.'));
        // return String(string).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // return String(string).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    uncomma: function(string) {
        let strings = String(string).split('.');
        strings[0] = String(strings[0]).replace(/[^\d]+/g, '');
        // console.log('uncomma', strings.join('.'))
        return (strings.join('.'));
        // return String(string).replace(/[^\d]+/g, '');
    },
    loadCss: function(url, id) {
        let link = document.createElement("link");
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = url;
            link.id = id;
        document.getElementsByTagName("head")[0].appendChild(link);
    },
    inArray(array, value) {
        for (let i = 0; i < array.length; i++) {
            if (array[i] == value) {
                return true;
            }
        }
        return false;
    },
    parseTimeString(time) {
        let reg   = /^\s*([1-9]\d*)([dhms])\s*$/;
        let match = time.match(reg);

        if (!match) {
            return null;
        }

        let num = parseInt(match[1]);
        switch (match[2]) {
            case 'd': num *= 24;
            case 'h': num *= 60;
            case 'm': num *= 60;
            case 's': num *= 1000;
        }
        // assert(num > 0);
        return num;
    },

    getTimeString(time) {
        return Vue.moment(time).format('HH:mm');
    },

    decodeBase64: function (string) {
        let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let result = '';
        let i = 0;
        do {
            let b1 = characters.indexOf(string.charAt(i++));
            let b2 = characters.indexOf(string.charAt(i++));
            let b3 = characters.indexOf(string.charAt(i++));
            let b4 = characters.indexOf(string.charAt(i++));
            let a = ((b1 & 0x3F) << 2) | ((b2 >> 4) & 0x3);
            let b = ((b2 & 0xF) << 4) | ((b3 >> 2) & 0xF);
            let c = ((b3 & 0x3) << 6) | (b4 & 0x3F);
            result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : '') + (c ? String.fromCharCode(c) : '');
        } while (i < string.length);
        return result;
    },

    mask: {
        left: function(_string, _mask) {
            let size = (_string.toString().length > _mask.toString().length ) ? _string.toString().length : _mask.toString().length;
            return _mask.toString() + _string.substr(_mask.toString().length, size);
        },
        right: function(_string, _mask) {
            let full = _string.toString() + _mask.toString();
            let size = (_string.length > _mask.toString().length ) ? _string.length : _mask.toString().length;
            return full.substr(_mask.toString().length, size);
        }
    },

    maskedUsername: function(username, is_mask)
    {
        if (is_mask && username) {
            return this.mask.left(username, '****');
        } else {
            return username;
        }
    },

    replace: function(string, _params) {
        let params = $.extend({}, _params);
        let matches = [];
        let match;
        let delete_keys = [];
        let regexp = new RegExp("\{.*?\}", "g");
        while ((match = regexp.exec(string)) != null) {
            matches.push(match[0]);
        }
        for(let i in matches) {
            let key = "";
            if (typeof matches[i] == "string") {
                key = matches[i].replace("{", "").replace("}", "");
                if (string.match("{"+ key +"}")) {
                    if (params[key] != undefined && String(params[key]) != "") {
                        string = string.replace(new RegExp(matches[i], 'gi'), params[key]);
                        delete_keys.push('{'+ key +'}');
                    }
                } else {
                    key = matches[i].replace("{", "").replace("?}", '');
                    if (string.match("{"+ key +"\\?}")) {
                        if (params[key] != undefined && String(params[key]) != "") {
                            string = string.replace(new RegExp("{"+ key +"\\?}", 'gi'), params[key]);
                        } else {
                            string = string.replace(new RegExp("{"+ key +"\\?}", 'gi'), '');
                        }
                        delete_keys.push('{'+ key +'?}');
                    }
                }
            }
        }
        matches = matches.filter(function(data) {
            for (let i in delete_keys) {
                if (data == delete_keys[i]) {
                    return false;
                }
            }
            return true;
        });
        if (matches.length > 0) {
            throw new Error(`Required parameter missing [${matches.join(',')}`);
        }
        return string;
    },

    isInt: function(number)
    {
        if (number % 1 > 0) {
            return false;
        }
        return true;
    },

    toFixed: function(n, decimals)
    {
        if (typeof decimals === 'undefined') {
            if (n % 1 === 0)
                decimals = 0;
            else
                decimals = 2;
        }
        return Number(n.toFixed(decimals));
    },

};
